export default [

     {
          path: '/classification',
          name: 'Classification',
          component: () => import("@/views/Page/Classification/Classification.vue"),
           meta: {
               title: 'Classification',
          },
     }
];